module.exports = __webpack_public_path__ + "img/nagoya.9da2a7d9.png";